{
  "collapse": "Sutraukti",
  "expand": "Išskleisti"
}
